import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "a-selection__action" }
const _hoisted_3 = {
  key: 0,
  class: "a-selection__item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: "a-selection a-button -action",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
    "data-qa": _ctx.PerformanceQASelectors.APPLIED_PROMO_CODE
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconComponent, {
        "icon-id": _ctx.iconName.Close
      }, null, 8, ["icon-id"])
    ]),
    (_ctx.value.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.value), 1))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}